
define('modules/application/wizard/classes/mainControlUnit',["app",

// Libs
"backbone",

//Classes
"./genericElement"],

function(app, Backbone, genericElement) {

  var mainControlUnit = _.extend({}, genericElement, {

    Views: {

      titleBar: genericElement.Views.titleBar.extend({
        template: "application/wizard/sections/mainControlUnit/titleBar",
        tagName:  "h3",
        events : {
          "click" : "titleBarClickedEventHandler"
        },

        initialize: function() {
          this.model.unbind("updateViews", this.setLabel);
          this.model.bind("updateViews", this.setLabel);
          this.model.titleBarView = this;
        },

        setLabel: function() {
          var captionToInsert = $.i18n._(this.get("packageClassLabel"));

          if (this.get("partOfKit"))
            captionToInsert += " (KIT)";

          if (this.get("packageClassLabel") !== null && this.get("packageClassLabel") !== "") {
            this.titleBarView.$el.find(".titleBarcontent span").html(captionToInsert);

            if (this.get("partOfKit"))
              this.titleBarView.$el.find(".titleBarcontent span").css("color", "#a0a2a3");

            this.titleBarView.$el.find(".titleBarcontent span").fadeIn(200);
          }
          else
            this.titleBarView.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        },

        removeLabel: function() {
          this.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        },

        enable: function() {
          this.$el.trigger("click");
        },

        disable: function() {
          this.$el.trigger("click");
        },

        onClose: function(){
          this.model.unbind("updateViews", this.setLabel);
        }
      }),

      content: genericElement.Views.content.extend({
        template: "application/wizard/sections/mainControlUnit/content",
        className: "mainControlUnit",

        events: {
          "change #mainControlUnit"    : "mainControlUnitChanged",
          "change .contactZoneSelector": "contactZoneSelectorChanged",
          "click .toggleInfoButton"    :  "toggleInfos"
        },

        serialize : function() {
          return { model: this.model, app : app };
        },

        initialize: function() {
          this.model.set("view", this);

          this.model.unbind("updateViews", this.render);
          this.model.bind("updateViews", this.render, this);

          window.BticinoS4B.eventAggregator.unbind("mainControlUnit:changeApproved", this.completeMainControlUnitChange);
          window.BticinoS4B.eventAggregator.bind("mainControlUnit:changeApproved", this.completeMainControlUnitChange, this);

          window.BticinoS4B.eventAggregator.unbind("mainControlUnit:changeNotApproved", this.revertMainControlUnitChange);
          window.BticinoS4B.eventAggregator.bind("mainControlUnit:changeNotApproved", this.revertMainControlUnitChange, this);

          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);

          if(BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"))
            this.model.accessoryLineChosenEventHandler(BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
        },

        toggleInfos : function(e) {
          return genericElement.Views.content.prototype.toggleInfos(e, this);
        },

        disableSection: function(force) {
          if (!this.model.get("enabled") || ((force !== undefined) && (force === true))) {
            this.$el.find("#mainControlUnit option").removeAttr("selected");
            this.$el.find("#mainControlUnit").attr("disabled", "disabled");
            this.$el.find("#mainControlUnit").removeAttr("rel");
            this.$el.find("span").remove();
            this.$el.find(".exampleImage").attr("src", "");
            this.$el.find(".description").html("");
            this.$el.find(".linkContainer").html("");
            window.customizeFormElements.call();
            this.hideDetails();
          }
        },

        contactZoneSelectorChanged : function(e) {
          var contactToConnect  = e.target.name.replace("zoneSelector-", ""),
              zoneToConnect     = e.target.value;
          this.model.connectToZone(contactToConnect, zoneToConnect);
        },

        enableSection: function() {
          if (this.model.get("enabled")) {
            this.$el.find("select#mainControlUnit").removeAttr("disabled");
            this.$el.find("span#selectmainControlUnit").removeClass("disabled");
            //this.showDetails();
          }
        },

        populateDropDown: function(mcus) {
          var dropDownView = this.$el.find("select#mainControlUnit");
          dropDownView.children("option:first").attr("selected", "selected");
          dropDownView.children("option:not(:first)").remove();

          for (var i = 0; i < mcus.length; i++)
            dropDownView.append("<option value=\"" + mcus[i].packageClassId + "\">" + $.i18n._(mcus[i].packageClassLabel) + "</option>");
        },

        mainControlUnitChanged: function(event, _force) {
          var force = false;

          if (_force)
            force = _force;

          this.model.tryToSetNewPackageClassId(event, event.target.value, force);
        },

        completeMainControlUnitChange : function(event) {
          this.naturalHideDone = true;
          this.hideDetails();
          this.showLoader();
          var mainControlUnitId     = ($(event.target).val() === "") ? undefined : $(event.target).val();
          var mainControlUnitLabel  = ($(event.target).children("option:selected").text() === "") ? undefined : $(event.target).children("option:selected").text();
          this.model.set("name", mainControlUnitLabel);
          this.model.set("id", mainControlUnitId);
          
          var systemId=window.BticinoS4B.Instances.Models.ApplicationModel.get("systemId");
          if(systemId=="#2"){
            BticinoS4B.solution.thermoregulation.inserted=true;
          }

        },

        revertMainControlUnitChange : function(event) {
          var mainControlUnitId     = this.model.get("id");
          var mainControlUnitLabel  = "";

          this.$el.find("#mainControlUnit").children("option").removeAttr("selected");

          var selectedMCU = _.filter(this.$el.find("#mainControlUnit").children("option"), function(mcu) {return mcu.value===mainControlUnitId;});

          if (selectedMCU.length==1)  {
            $(selectedMCU[0]).attr("selected", "selected");
            mainControlUnitLabel = selectedMCU[0].label;
          }

          this.$el.find("#selectmainControlUnit").text(mainControlUnitLabel);
        },

        showDetails: function() {
          this.$el.find(".exampleImage").fadeIn(200);
          this.$el.find(".productCode").fadeIn(200);
          this.$el.find(".description").fadeIn(200);
          this.$el.find(".linkContainer").fadeTo(200,1);
        },

        hideDetails: function() {
          this.$el.find(".exampleImage").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".productCode").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".description").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".linkContainer").fadeTo(200,0);
        },

        showLoader: function() {
          this.$el.find(".mini-loader").fadeIn(200);
        },

        hideLoader: function(callback) {
          var that = this;
          this.$el.find(".mini-loader").fadeOut(200, function() {
            $(this).hide();
            callback.call(that);
          });
        },

        isOpen: function() {
          return this.$el.css("display") == "block";
        },

        afterRender: function() {
          var that = this;

          setTimeout(function() {
            window.customizeFormElements.call();
          }, 100);
        },

        onClose: function(){
          this.model.unbind("change #mainControlUnit");
        }
      })

    },

    Model: genericElement.Model.extend({
      defaults: {
        enabled           : false,
        id                : undefined,

        catalogId         : undefined,
        image             : undefined,
        links             : {
          images: [],
          papers: [],
          videos: []
        },
        price             : undefined,
        productCode       : undefined,
        productDescription: undefined,
        productLabel      : undefined,
        maxZoneNumber     : undefined,
        infoQuote         : "IDS_WGENTT_000003"
      },

      initialize: function() {
        var that = this;

        //Bind on accessory line selection
        window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen',                  this.accessoryLineChosenEventHandler);
        window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen',                    this.accessoryLineChosenEventHandler, this);

        //Bind on accessory line removal
        window.BticinoS4B.eventAggregator.unbind('accessoryLine:removed',                 this.accessoryLineRemovedEventHandler);
        window.BticinoS4B.eventAggregator.bind('accessoryLine:removed',                   this.accessoryLineRemovedEventHandler, this);

        //Bind on materials overview model delivery request
        window.BticinoS4B.eventAggregator.unbind("modelDeliver:request",                  this.deliverModel);
        window.BticinoS4B.eventAggregator.bind("modelDeliver:request",                    this.deliverModel, this);

        window.BticinoS4B.eventAggregator.unbind("load:Project",                          this.loadProject);
        window.BticinoS4B.eventAggregator.bind("load:Project",                            this.loadProject, this);

        window.BticinoS4B.eventAggregator.unbind("mainControlUnit:addedFromKit",          this.productAddedFromKitEventHandler);
        window.BticinoS4B.eventAggregator.bind("mainControlUnit:addedFromKit",            this.productAddedFromKitEventHandler, this);

        window.BticinoS4B.eventAggregator.unbind("removeKitItems",                        this.removeKitItems);
        window.BticinoS4B.eventAggregator.bind("removeKitItems",                          this.removeKitItems, this);

        window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",                this.deliverCurrent, this);

        this.unbind("change:id",                                            this.idChanged);
        this.bind("change:id",                                              this.idChanged);
        
      },

      accessoryLineChosenEventHandler  : function(accessoryLineId) {
        this.fetchMCUs(accessoryLineId);
        this.set("accessoryLineId", accessoryLineId);
        this.disableSection();
        this.enableSection();
      },

      accessoryLineRemovedEventHandler : function(accessoryLineId) {
        this.set("accessoryLineId", "");
        this.removeValues();
        this.disableSection();
      },

      removeKitItems                   : function() {
        if (this.get("partOfKit"))
        {

          window.BticinoS4B.eventAggregator.trigger("contactsDisconnectionRequired");

          this.removeValues();
          this.trigger("updateViews");
          this.trigger("render:requested");
        }
      },

      productAddedFromKitEventHandler : function(addedMainControlUnit) {
        this.set("partOfKit", true);
        this.set("kitValue",  1);
        this.set("id", addedMainControlUnit.packageClassId);
      },

      connectToZone                    : function(contactToConnect, zoneToConnect) {
        contactToConnect  = this.get("specialVars").contacts[contactToConnect];
        zoneToConnect     = Number(zoneToConnect);

        //window.BticinoS4B.eventAggregator.trigger("contactsDisconnectionRequired");
        window.BticinoS4B.eventAggregator.trigger("zonesWithoutOneFreePProtection:check");

        var zonesWithoutOneFreePProtection = BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") : [],
            allZones                       = [],
            maxZoneNumber                  = this.get("specialVars").maxZoneNumber,
            i                              = 0,
            j                              = 0;

        for (j=1; j<=maxZoneNumber; j++)
          allZones.push(j);

        var zonesWithFreePerimetralProtection = _.difference(allZones, zonesWithoutOneFreePProtection);

        if ($.inArray( zoneToConnect, zonesWithFreePerimetralProtection)!==-1)
        {

          if (contactToConnect.connectedTo)
          {
            if (contactToConnect.connectedTo!==zoneToConnect)
            {
              window.BticinoS4B.eventAggregator.trigger("contactDisconnectionRequired",{
                contactToDisconnect : contactToConnect
              });
            }
          }

          contactToConnect.connectedTo = zoneToConnect;

          window.BticinoS4B.eventAggregator.trigger("contactConnectionRequired", {
            contactToConnect: contactToConnect,
            zoneToConnect: zoneToConnect
          });
        }
        else
        {
          alert("Zone not available");
        }
        this.trigger("render:requested");

        switch(BticinoS4B.vars.system.id)
        {
        case '#2':
          BticinoS4B.solution.thermoregulation.zonesWithoutOneFreePProtection = [];
          break;
        case '#4':
          BticinoS4B.solution.intrusionDetection.zonesWithoutOneFreePProtection = [];
          break;
        case '#5+6':
          BticinoS4B.solution.audioVideo.zonesWithoutOneFreePProtection = [];
          break;
        case '#13+20':
          BticinoS4B.solution.automation.zonesWithoutOneFreePProtection = [];
          break;
        case '#13':
          BticinoS4B.solution.automationSimple.zonesWithoutOneFreePProtection = [];
          break;
        case '#21':
          BticinoS4B.solution.energyManagement.zonesWithoutOneFreePProtection = [];
          break;
        }
        BticinoS4B.Instances.Models.ApplicationModel.set("zonesWithoutOneFreePProtection", []);
      },

      deliverModel: function() {
        var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            i            = 0;

        dataProvider.addItems("externalItems", {
          productCode       : this.get("productCode"),
          productLabel      : this.get("productLabel"),
          packageClassLabel : this.get("packageClassLabel"),
          kitValue          : this.get("kitValue"),
          partOfKit         : this.get("partOfKit"),
          quantity          : 1,
          price             : this.get("price")
        });

        if (this.get("secondaryProducts"))
        {
          for (i=0; i<this.get("secondaryProducts").length; i++)
          {
            dataProvider.addItems("externalItems", {
              productCode       : this.get("secondaryProducts")[i].productCode,
              productLabel      : this.get("secondaryProducts")[i].productLabel,
              packageClassLabel : this.get("secondaryProducts")[i].packageClassLabel,
              kitValue          : this.get("kitValue"),
              partOfKit         : this.get("partOfKit"),
              quantity          : 1,
              price             : this.get("secondaryProducts")[i].price
            });
          }
        }

        switch(BticinoS4B.vars.system.id)
        {
        case '#2':
          BticinoS4B.solution.thermoregulation.mainControlUnit = this;
          break;
        case '#4':
          BticinoS4B.solution.intrusionDetection.mainControlUnit = this;
          break;
        case '#5+6':
          BticinoS4B.solution.audioVideo.mainControlUnit = this;
          break;
        case '#13+20':
          BticinoS4B.solution.automation.mainControlUnit = this;
          break;
        }
        BticinoS4B.Instances.Models.ApplicationModel.set("mainControlUnit", this);
      },

      fetchMCUs: function() {
        var that            = this;
        var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");

        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(that.get("idWizardChoice"), function(data) {

          //Retrieve branch catalog id
          var branchLocalizationId = BticinoS4B.Instances.Models.ApplicationModel.get("branchLocalizationId");

          //Sorting elements by packageClassId
          that.fetchedMCUs = data.packages;

          //Converting specialData from json to object
          for (var i=0; i<data.packages.length; i++)
            data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);

          if (that.get("view"))
            that.get("view").populateDropDown(that.fetchedMCUs);
        });
      },

      getPackageDetails: function(packageClassId) {
        var that = this;

        if (packageClassId!==undefined)
        {
          accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
          BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageClassId, function(data) {
            data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
            var mainProduct       = _.filter(data.products,function(product) {return (product.mnemonic===1);});

            if (mainProduct.length>0)
              mainProduct=mainProduct[0];

            _.extend(that.attributes, mainProduct);

            var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

            that.set("secondaryProducts", secondaryProducts);

            that.set("maxZoneNumber", that.get("specialVars").maxZoneNumber);
            
            //messo limite 19 per thermoregulation perchè Giorgio ha chiesto così in data 10/06/2014
            switch(BticinoS4B.vars.system.id)
            {
            case '#2':
              if(that.get("specialVars").maxZoneNumber==99){
                BticinoS4B.solution.thermoregulation.maxZoneNumber = 19;
                that.set("maxZoneNumber",19);
              }else
                BticinoS4B.solution.thermoregulation.maxZoneNumber = that.get("maxZoneNumber");
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.maxZoneNumber = that.get("maxZoneNumber");
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.maxZoneNumber = that.get("maxZoneNumber");
              break;
            case '#13+20':
              BticinoS4B.solution.automation.maxZoneNumber = that.get("maxZoneNumber");
              break;
            }
            BticinoS4B.Instances.Models.ApplicationModel.set("maxZoneNumber", that.get("maxZoneNumber"));

            if (that.get("id") !== undefined) {
              that.get("stepEventAggregator").trigger("mainControlUnit:chosen",that);
              window.BticinoS4B.eventAggregator.trigger("mainControlUnit:chosen", that);
              that.trigger("updateViews");

            } else {
              this.get("stepEventAggregator").trigger("mainControlUnit:removed");
              window.BticinoS4B.eventAggregator.trigger("mainControlUnit:removed", that);
              that.trigger("updateViews");
            }

            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          });
        }
        else
        {
          this.get("stepEventAggregator").trigger("mainControlUnit:removed");
          window.BticinoS4B.eventAggregator.trigger("mainControlUnit:removed");
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        }
      },

      idChanged: function(e) {
        var that        = this;
        var selectedMCU = _.filter(_.extend({}, this.fetchedMCUs), function(mcu){return mcu.packageClassId==that.id;});

        if (selectedMCU.length===0)
          BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(that.get("id"), function(data) {
            _.extend(that.attributes, data);
            that.getPackageDetails(that.get("id"));
            that.trigger("updateViews");
          });
        else
        {
          _.extend(that.attributes, selectedMCU[0]);
          that.getPackageDetails(selectedMCU[0].packageClassId);
          that.trigger("updateViews");
        }

        var mergeContactData = function(data) {
          data.specialVars                    = JSON.parse(data.specialVars);
          data.mainControlUnitEventAggregator = _.extend({}, Backbone.Events);
          contacts[i]                         = data;

          contacts[i].mainControlUnitEventAggregator.bind("render:requested",   function() {
            this.trigger("render:requested");
          }, that);

          contacts[i].mainControlUnitEventAggregator.bind("zoneNumber:changed", function(newZoneNumber) {
            this.connectedTo = newZoneNumber;
            this.mainControlUnitEventAggregator.trigger("render:requested");
          }, contacts[i]);
        };

        window.BticinoS4B.eventAggregator.trigger("contactsDisconnectionRequired");

        var zonesWithoutOneFreePProtection = [],
            allZones                       = [],
            maxZoneNumber                  = 0,
            i                              = 0,
            j                              = 0;

        var zonesWithFreePerimetralProtection = _.difference(allZones, zonesWithoutOneFreePProtection);

        if (this.get("specialVars").contacts)
          for (i=0, contacts = this.get("specialVars").contacts, contactsLength = contacts.length; i<contactsLength; i++)
          {
            window.BticinoS4B.eventAggregator.trigger("zonesWithoutOneFreePProtection:check");

            if (typeof contacts[i] !== "object")
              BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(contacts[i], mergeContactData);

            maxZoneNumber = this.get("specialVars").maxZoneNumber;
            allZones = [];
            for (j=1; j<=maxZoneNumber; j++)
              allZones.push(j);
            zonesWithoutOneFreePProtection = BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") ? BticinoS4B.Instances.Models.ApplicationModel.get("zonesWithoutOneFreePProtection") : [];
            zonesWithFreePerimetralProtection       = _.difference(allZones, zonesWithoutOneFreePProtection);
            this.connectToZone(i, zonesWithFreePerimetralProtection[0]);
          }

        this.trigger("updateViews");
      },

      disableSection            : function() {
        var that = this;

        if (this.get("enabled")) {
          this.set("enabled", false);
          this.get("view").disableSection();
          this.titleBarView.removeLabel();
          if (this.get("view").isOpen()) this.titleBarView.disable();
        }

        this.set("id", undefined);
      },

      enableSection             : function() {
        var that = this;
        if (!this.get("enabled")) {
          this.set("enabled", true);
          this.get("view").enableSection();
        }
      },

      removeValues              :  function() {
        this.set("image","");
        this.set("links",{images:[], papers:[], videos:[]});
        this.set("mnemonic","");
        this.set("name","");
        this.set("optionalPackages","");
        this.set("packageActuator","");
        this.set("packageClassId","");
        this.set("packageClassLabel","");
        this.set("packageInDepth","");
        this.set("packageLoad","");
        this.set("price","");
        this.set("productCode","");
        this.set("productInDepth","");
        this.set("productLabel","");
        this.set("productDescription","");
        this.set("wizardChoiceDescription","");
        this.set("wizardChoiceLabel","");
        this.set("packageClassDescription","");
        this.set("packageClassId","");
        this.set("packageClassLabel","");
        this.set("partOfKit", false);
        this.set("specialVars", "");
        this.set("id", "");
        window.BticinoS4B.eventAggregator.trigger("contactsDisconnectionRequired");
      },

      loadProject               : function(model) {
        var mainControlUnit = model.mainControlUnit;

        if(mainControlUnit)
        {
          this.set("id", mainControlUnit.packageClassId);
          this.set("partOfKit", mainControlUnit.partOfKit);
          this.set("kitValue", mainControlUnit.kitValue);

          if (mainControlUnit.contacts && mainControlUnit.contacts.length>0)
          {
            var actualContacts = this.get("specialVars").contacts;
            if(actualContacts)
              for (var i = actualContacts.length - 1; i >= 0; i--) {
                actualContacts[i].connectedTo = mainControlUnit.contacts[i].connectedTo;
              }
          }
          this.trigger("render:requested");
        }
      },

      onClose                   : function() {
        this.unbind("change:id");
      },

      deliverCurrent            : function() {
        var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
        if (this.get("specialVars") && consumptionIndicatorModel) {
          var currentConsumption        = this.get("specialVars").currentConsumption;

          if (currentConsumption<0)
            consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
          else
            consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
        }
      },

      tryToSetNewPackageClassId : function(event, newPackageClassId, _force) {
        var choosenMCU = _.filter(this.fetchedMCUs, function(mcu){ return mcu.packageClassId===newPackageClassId;})[0],
            force      = false;

        if (_force)
          force = _force;

        if (choosenMCU)
          window.BticinoS4B.eventAggregator.trigger("mainControlUnit:selected", this.model, event, choosenMCU.specialVars.maxZoneNumber, force);
      }

    })

  });

  // Required, return the module for AMD compliance
  return mainControlUnit;

});